import { render, staticRenderFns } from "./UserAdmin.vue?vue&type=template&id=7516804c&scoped=true&"
import script from "./UserAdmin.vue?vue&type=script&lang=js&"
export * from "./UserAdmin.vue?vue&type=script&lang=js&"
import style0 from "./UserAdmin.vue?vue&type=style&index=0&id=7516804c&prod&lang=css&"
import style1 from "./UserAdmin.vue?vue&type=style&index=1&id=7516804c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7516804c",
  null
  
)

export default component.exports